const rootPath = '/img/logo'

const logoVariants = {
  white252x80: `${rootPath}/my-omnia-white-252x80.png`,
  whiteNoText160x160: `${rootPath}/my-omnia-no-text-white-160x160.png`,
  grayNoText88x88: `${rootPath}/my-omnia-no-text-gray-88x88.png`,
  purple252x80: `${rootPath}/my-omnia-purple-252x80.png`,
  pure500x499: `${rootPath}/my-omnia-pure-500x499.png`,
  purpleNoText160x160: `${rootPath}/my-omnia-no-text-160x160.png`,
  purpleNoText112x112op50pct: `${rootPath}/my-omnia-no-text-0.5-112x112.png`,
  mediumBlueText145x31: `${rootPath}/my-omnia-text-only-medium-blue-145x31.png`,
  whiteText145x31: `${rootPath}/my-omnia-text-only-white-145x31.png`,
}

export default logoVariants